import { defineStore } from 'pinia';
import { ref, watchEffect } from 'vue';

export interface AppStore {
  mode: any;
  switchMode: (val: 'light' | 'dark') => void;
  autoMode: boolean;
  setAutoMode: (val: boolean) => void;
}

const useAppStore = defineStore(
  'app',
  () => {
    // 默认不跟随系统
    const autoMode = ref(false);
    // 当前主题
    const mode = ref<'light' | 'dark'>('light');

    // 跟随系统变化
    const updateModeBySystem = () => {
      if (autoMode.value) {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        console.log('检测到系统主题变化，更新主题', window.matchMedia('(prefers-color-scheme: dark)').matches);

        mode.value = isDark ? 'dark' : 'light';
      }
    };

    // 监听系统主题变化
    let media: MediaQueryList | null = null;
    watchEffect(() => {
      if (autoMode.value) {
        console.log('自动模式');
        media = window.matchMedia('(prefers-color-scheme: dark)');
        media.addEventListener('change', updateModeBySystem);
        updateModeBySystem();
      } else if (media) {
        media.removeEventListener('change', updateModeBySystem);
      }
    });

    // 手动切换
    const switchMode = (val: 'light' | 'dark') => {
      autoMode.value = false;
      mode.value = val;
    };

    // 设置是否自动
    const setAutoMode = (val: boolean) => {
      autoMode.value = val;
      if (val) {
        updateModeBySystem();
      }
    };

    return {
      mode,
      autoMode,
      switchMode,
      setAutoMode,
    };
  },
  {
    persist: true,
  },
);

export default useAppStore;
